import { BookingType } from '../../types/booking';
import {
	deleteFromBookingStorage,
	setBookingStorage,
	updateBookingStorage,
} from '../../utils/booking';

import { BookingStorageAction } from './types';

const bookingStorageReducer = (state: BookingType[], action: BookingStorageAction) => {
	switch (action.type) {
		case 'set':
			setBookingStorage(action.payload);
			return action.payload;
		case 'update':
			return updateBookingStorage(action.payload);
		case 'delete':
			return deleteFromBookingStorage(action.payload);
		default:
			return state;
	}
};

export default bookingStorageReducer;
